export const profile = {
  name: "Balarathinam T",
  role: "Associate Software Engineer",
  headline: "Full Stack JavaScript Developer",
  location: "Chennai, Tamil Nadu, India",
  email: "bala01225@gmail.com",
  portfolio: "https://balarathinam-portfolio.netlify.app/",
  linkedin: "https://www.linkedin.com/in/balarathinam-t-350b5821b",
  github: "https://github.com/Ba7arathinam",
  resume:
    "https://drive.google.com/file/d/1XwVJ6oUIdivswlH-fjhUgw3HLBRvquMF/view",
  summary:
    "Associate Software Engineer at BU Soft Tech building scalable enterprise web applications with Angular, Node.js, TypeScript, LoopBack 4, and MySQL. I focus on reusable frontend architecture, reliable API integration, and clean full-stack delivery for business-critical products.",
  focus: [
    "Angular enterprise modules",
    "LoopBack 4 API services",
    "MySQL data flows",
    "Full-stack product delivery",
  ],
};

export const metrics = [
  { value: "2.5+", label: "Years at BU Soft Tech" },
  { value: "4", label: "Professional roles" },
  { value: "15+", label: "Core technologies" },
];

export const experiences = [
  {
    role: "Associate Software Engineer",
    company: "BU Soft Tech",
    period: "June 2024 - Present",
    location: "Chennai, Tamil Nadu, India",
    type: "Current",
    summary:
      "Developing and maintaining enterprise web applications with Angular, JavaScript, TypeScript, Node.js, LoopBack 4, and MySQL.",
    highlights: [
      "Built dynamic, scalable Angular interfaces with reusable modules and services.",
      "Contributed to a CRM product across frontend and backend during the initial full-stack phase.",
      "Integrated APIs and backend services with MySQL-backed application workflows.",
      "Currently contributing to an enterprise daycare management system by improving Angular modules and application functionality.",
      "Supported ASP.NET Web Forms UI work with HTML-based interface components when project needs required it.",
    ],
  },
  {
    role: "Software Engineer Trainee",
    company: "BU Soft Tech",
    period: "January 2024 - July 2024",
    location: "Chennai, Tamil Nadu, India",
    type: "Foundation",
    summary:
      "Worked through the software development lifecycle while building strong engineering fundamentals.",
    highlights: [
      "Collaborated with cross-functional teams to develop, test, and deploy software solutions.",
      "Applied coding best practices across implementation, debugging, and delivery tasks.",
      "Built practical web development experience that led into the Associate Software Engineer role.",
    ],
  },
  {
    role: "Technical Support Intern",
    company: "GUVI Geek Networks, IITM Research Park",
    period: "August 2023 - November 2023",
    location: "Chennai, Tamil Nadu, India",
    type: "Internship",
    summary:
      "Created responsive UI experiences and supported React-based development workflows.",
    highlights: [
      "Crafted responsive interfaces with HTML5, CSS3, Bootstrap, JavaScript, ReactJS, Material UI, and Redux.",
      "Translated UI and UX requirements into modular frontend components.",
      "Improved user experience across devices while participating in code review workflows.",
    ],
  },
  {
    role: "Bot Developer Trainee",
    company: "BeezLabs",
    period: "June 2022 - July 2022",
    location: "Chennai, Tamil Nadu, India",
    type: "Trainee",
    summary:
      "Early technical role focused on automation thinking, structured problem solving, and software fundamentals.",
    highlights: [
      "Explored bot development concepts and practical automation workflows.",
      "Strengthened debugging, logical thinking, and implementation discipline.",
    ],
  },
];

export const skills = [
  {
    title: "Frontend Engineering",
    description: "Interfaces, design systems, and reusable product modules.",
    items: [
      { name: "Angular", icon: "https://cdn.simpleicons.org/angular/DD0031" },
      { name: "Angular Material", icon: "https://cdn.simpleicons.org/angular/DE2A5A" },
      { name: "Angular CLI", icon: "https://cdn.simpleicons.org/angular/EF4444" },
      { name: "React", icon: "https://cdn.simpleicons.org/react/61DAFB" },
      { name: "Redux", icon: "https://cdn.simpleicons.org/redux/764ABC" },
      { name: "TypeScript", icon: "https://cdn.simpleicons.org/typescript/3178C6" },
      { name: "JavaScript", icon: "https://cdn.simpleicons.org/javascript/F7DF1E" },
      { name: "HTML5", icon: "https://cdn.simpleicons.org/html5/E34F26" },
      { name: "CSS3", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/css3/css3-original.svg" },
      { name: "Bootstrap", icon: "https://cdn.simpleicons.org/bootstrap/7952B3" },
      { name: "Material UI", icon: "https://cdn.simpleicons.org/mui/007FFF" },
    ],
  },
  {
    title: "Backend & Data",
    description: "APIs, services, integrations, and database-backed workflows.",
    items: [
      { name: "Node.js", icon: "https://cdn.simpleicons.org/nodedotjs/5FA04E" },
      { name: "LoopBack 4", icon: "https://cdn.simpleicons.org/loopback/3F5DFF" },
      { name: "Express", icon: "https://cdn.simpleicons.org/express/FFFFFF" },
      { name: "MySQL", icon: "https://cdn.simpleicons.org/mysql/4479A1" },
      { name: "MongoDB", icon: "https://cdn.simpleicons.org/mongodb/47A248" },
      { name: "REST APIs", icon: "https://cdn.simpleicons.org/postman/FF6C37" },
    ],
  },
  {
    title: "Tools & Workflow",
    description: "Everyday tools for clean delivery and collaboration.",
    items: [
      { name: "Git", icon: "https://cdn.simpleicons.org/git/F05032" },
      { name: "GitHub", icon: "https://cdn.simpleicons.org/github/FFFFFF" },
      { name: "Postman", icon: "https://cdn.simpleicons.org/postman/FF6C37" },
      { name: "VS Code", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vscode/vscode-original.svg" },
      { name: "npm", icon: "https://cdn.simpleicons.org/npm/CB3837" },
      { name: "ASP.NET UI", icon: "https://cdn.simpleicons.org/dotnet/512BD4" },
    ],
  },
];

export const projects = [
  {
    title: "Enterprise Daycare Management",
    type: "Current Work",
    description:
      "Angular module development and application improvements for an enterprise daycare management platform.",
    tags: ["Angular", "TypeScript", "Enterprise UI", "MySQL"],
    accent: "teal",
  },
  {
    title: "CRM Product Modules",
    type: "Professional Work",
    description:
      "Full-stack contribution across frontend and backend workflows for CRM product development.",
    tags: ["Angular", "Node.js", "LoopBack 4", "MySQL"],
    accent: "blue",
  },
  {
    title: "ToDo App",
    type: "Personal Project",
    description:
      "Full-stack task management app with CRUD operations, API integration, and persistent storage.",
    tags: ["React", "Node.js", "Express", "MongoDB"],
    projectLink: "https://too-do-apz.netlify.app/",
    gitLink: "https://github.com/Ba7arathinam/todo-app-frontend",
    gitLink1: "https://github.com/Ba7arathinam/todo-app-backend",
    accent: "green",
  },
  {
    title: "Login Auth",
    type: "Personal Project",
    description:
      "Authentication flow with JWT, password reset, secure sessions, and backend API handling.",
    tags: ["Node.js", "Express", "MongoDB", "JWT"],
    projectLink: "https://password-resets.netlify.app/",
    gitLink: "https://github.com/Ba7arathinam/Password_Reset_Flow_Frontend",
    gitLink1: "https://github.com/Ba7arathinam/Password_Reset_Flow_Backend",
    accent: "violet",
  },
  {
    title: "Blog App",
    type: "Personal Project",
    description:
      "Blogging platform with create, read, update, and delete workflows across frontend and backend.",
    tags: ["React", "Node.js", "Express", "MongoDB"],
    projectLink: "https://blogging-apps.netlify.app/",
    gitLink: "https://github.com/Ba7arathinam/Blog-app-Frontend",
    gitLink1: "https://github.com/Ba7arathinam/Blog-app-Backend",
    accent: "orange",
  },
  {
    title: "Equipment Rental App",
    type: "Personal Project",
    description:
      "Rental platform UI and product management experience with responsive screens and API data.",
    tags: ["React", "MockAPI", "Node.js", "Material UI"],
    projectLink: "https://equipment-rental-app.netlify.app/",
    gitLink: "https://github.com/Ba7arathinam/Equipment-Rental-Frontend",
    gitLink1: "https://github.com/Ba7arathinam/Equipment-Rental-Backend",
    accent: "pink",
  },
  {
    title: "Movie Rating App",
    type: "Personal Project",
    description:
      "Movie review and rating interface with API-driven data, Material UI screens, and responsive user flows.",
    tags: ["React", "Material UI", "MongoDB", "Node.js"],
    projectLink: "https://resplendent-strudel-4e8f07.netlify.app/",
    gitLink: "https://github.com/Ba7arathinam/movie-rating-app",
    accent: "violet",
  },
];

export const certifications = [
  { title: "React.js", issuer: "LinkedIn Profile Certification" },
  {
    title: "HTML5 Application Development Fundamentals",
    issuer: "LinkedIn Profile Certification",
  },
  { title: "MongoDB", issuer: "LinkedIn Profile Certification" },
  { title: "CSS3", issuer: "LinkedIn Profile Certification" },
  {
    title: "Full Stack Development (MERN Stack)",
    issuer: "GUVI Geek Networks / IIT Madras",
  },
];

export const education = [
  {
    school: "Indian Institute of Technology, Madras / GUVI Geek Networks",
    program: "Full Stack Development (MERN Stack)",
    period: "August 2022 - February 2023",
  },
  {
    school: "Rajalakshmi Engineering College",
    program: "BE Aeronautical Engineering",
    period: "2018 - 2022",
  },
];
